export default __webpack_public_path__ + "static/media/txt.663915be.svg";